import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { KeyEventUtil } from 'utils'

const ImporteFormGroup = ({ iTouched, iError, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('select-moneda', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='IMPORTE' htmlFor='input-importe' md={6} alignRightAt='md' />
      <Col md={6}>
        <Field name='importe'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              id='input-importe'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteFormGroup)
